<template>
  <v-container fluid justify-center>
    <v-progress-linear :indeterminate="true" v-if="isLoading"></v-progress-linear>
        <v-flex class="elevation-1 pa-3 ma-2">
          <v-toolbar class="mb-2" color="primary" dark>
            <v-toolbar-title v-if="collegeDocument">
              {{ $$t('title') }} {{ collegeDocument.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="action('edit')" v-if="!editing">
              <v-icon>{{ mdiSort }}</v-icon>
            </v-btn>
            <v-btn icon @click="action('done')" v-if="editing">
              <v-icon>{{ mdiCheck }}</v-icon>
            </v-btn>
            <v-btn icon @click="action('undo')" v-if="editing">
              <v-icon>{{ mdiClose }}</v-icon>
            </v-btn>
          </v-toolbar>
          <v-btn class="mr-3" color="default" :to="{
            name: 'membership-ListCollegeDocument',
            query: { collegeModuleId: collegeDocument.collegeModuleId }
          }">
            <v-icon small>{{ mdiArrowLeft }}</v-icon>
            {{ $t('common.back')}}
          </v-btn>
          <modal-college-document-question @added="added" :ordering="items.length" />
          <v-list-item two-line>
            <draggable :options="options" v-model="items" style="width: 100%">
              <template v-for="(item, i) in items">
                <v-list-item v-if="item" :key="`item-${item.id}`" avatar>
                  <v-list-item-avatar color="grey">
                    <span>{{ i + 1 }}</span>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="item.content"
                      style="font-size: 1.5rem">
                    </v-list-item-title>
                    <list-college-document-answer
                      :collegeDocumentQuestionId="item.id"
                      :collegeDocumentId="collegeDocumentId"
                    />
                  </v-list-item-content>

                  <v-list-item-action style="align-self: start;">
                    <v-btn-toggle mandatory multiple>
                      <v-btn small :to="{
                        name: 'membership-EditCollegeDocumentQuestion',
                        query: { id: item.id }
                      }">
                        {{ $t('common.buttons.edit')}}
                      </v-btn>
                      <v-btn small color="error" @click="remove(item.id)">
                        {{ $t('common.buttons.delete')}}
                      </v-btn>
                    </v-btn-toggle>
                  </v-list-item-action>

                </v-list-item>
                <v-divider
                  v-if="item"
                  :key="`divider-${item.id}`"
                ></v-divider>
              </template>
            </draggable>
          </v-list-item>
        </v-flex>
      </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import draggable from 'vuedraggable';
import {
  mdiSort, mdiPencil, mdiCheck, mdiClose, mdiDelete, mdiArrowLeft,
} from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import ModalCollegeDocumentQuestion from '../components/ModalCollegeDocumentQuestion.vue';
import ListCollegeDocumentAnswer from '../components/ListCollegeDocumentAnswer.vue';

export default {
  name: 'ManageQuestions',
  module: 'Membership',
  mixins: [loading],
  components: {
    draggable,
    ModalCollegeDocumentQuestion,
    ListCollegeDocumentAnswer,
  },
  data() {
    return {
      collegeDocumentId: this.$route?.query.collegeDocumentId,
      mdiSort,
      mdiCheck,
      mdiClose,
      mdiPencil,
      mdiDelete,
      mdiArrowLeft,
      before: null,
      editing: false,
      items: [],
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('collegeDocumentQuestions', ['collegeDocumentQuestions']),
    ...mapState('collegeDocuments', ['collegeDocument']),
    options() {
      return {
        disabled: !this.editing,
      };
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('collegeDocumentQuestions', ['LOAD_collegeDocumentQuestions', 'DELETE_collegeDocumentQuestion', 'UPDATE_collegeDocumentQuestion']),
    ...mapActions('collegeDocuments', ['LOAD_collegeDocument']),
    action(e) {
      if (e === 'done') {
        const { items } = this;
        // eslint-disable-next-line max-len
        const itemsToUpdate = items.map((i) => this.UPDATE_collegeDocumentQuestion({ id: i.id, ordering: items.indexOf(i) }));
        Promise.all(itemsToUpdate);
      }
      if (e === 'edit') this.before = Object.assign([], this.items);
      if (e === 'undo') this.items = this.before;
      this.editing = !this.editing;
    },
    async added() {
      await this.refresh();
    },
    async refresh() {
      this.isLoading = true;
      await this.LOAD_collegeDocument(this.collegeDocumentId);
      this.items = await this.LOAD_collegeDocumentQuestions(this.collegeDocumentId);
      this.isLoading = false;
    },
    async remove(CollegeDocumentQuestion) {
      const result = await this.$confirm(this.$t('common.phrases.confirmDelete'));
      if (result) {
        this.isLoading = true;
        await this.DELETE_collegeDocumentQuestion(CollegeDocumentQuestion);
        this.isLoading = false;
        await this.refresh();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.draggable-flex {
  display: inherit;
  flex-direction: inherit;
}
</style>
